/** Copyright © 2013-2022 DataYes, All Rights Reserved. */

import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import logoPng from 'components/global-header-login/header/images/logo-icon.png';
import { StyledHeader } from '../style';

type Props = {
  onClose?: (...args: any[]) => any;
};

const Header = ({ onClose }: Props) => (
  <StyledHeader>
    <img src={logoPng} alt="" />
    <span>萝卜投研</span>
    {onClose && (
      <button type="button" aria-label="Close" className="modal-close" onClick={onClose}>
        <CloseOutlined />
      </button>
    )}
  </StyledHeader>
);

export default Header;
